<template>
  <div class="toggle-tickets">
    <b-button-group class="mt-4 mb-0">
      <b-button
        v-for="[key, val] in items"
        :key="key"
        variant="outline-primary"
        :class="{ active: val === value }"
        @click="$emit('input', val)"
      >
        {{ key }}
      </b-button>
    </b-button-group>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
    },
    value: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: String | Boolean,
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/styles/custom/colors';

.btn-group {
  .btn {
    background: map-get($theme-colors, 'gray06');
    border: 1px solid map-get($theme-colors, 'gray-dark');
    border-radius: initial !important;
    color: map-get($theme-colors, 'gray-dark');
    font-weight: 500;

    &.active {
      background: map-get($theme-colors, 'white');
      border: 1px solid transparentize(map-get($theme-colors, 'purple01'), 0.5);
      color: map-get($theme-colors, 'primary');
      box-shadow: 0 2px 4px
        transparentize(map-get($theme-colors, 'purple02'), 0.75);
      z-index: 0;
    }

    @media (max-width: 425px) {
      font-size: small;
    }

    &:first-child {
      border-radius: 35px 0 0 35px !important;
    }

    &:last-child {
      border-radius: 0 35px 35px 0 !important;
    }
  }
}
</style>
